export default __webpack_public_path__ + "static/media/failed.e2904af7.png";